// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__2r37K","label":"CheckBox_label__Q0Qga","input":"CheckBox_input__lOmO+"};